export const configKeys = {
  default: ["config"],
};
